function updateMasterSelectors() {
    const masterSelectors = document.querySelectorAll('[name="id"]');
    const selectedOptions = {};
    document.querySelectorAll('.selector-wrapper select').forEach(select => {
        const mobileSelect = select.closest('.mobile-form') !== null
        if (window.innerWidth < 1200 && mobileSelect) {
            selectedOptions[select.dataset.index] = select.value
        } else if (window.innerWidth >= 1200 && !mobileSelect) {
            selectedOptions[select.dataset.index] = select.value
        }
        
    })
    masterSelectors.forEach(selector => {
        const variants = [...selector.querySelectorAll('option')]
        const matchingVariantID = getMatchingVariant(selectedOptions, variants)
        const params = `variant=${matchingVariantID}`
        window.location.href =`http://${window.location.host}${window.location.pathname}?${params}`
    })
}

function getMatchingVariant(options, variants) {
    const matchingVariant = variants.find(variant => {
        const data = JSON.parse(variant.dataset.variant);
        for ([key, value] of Object.entries(options)) {
            if (data[key] !== value) return false;
        }
        return true;
    })
    return JSON.parse(matchingVariant.dataset.variant).id;
}

(() => {
    document.querySelectorAll('.selector-wrapper select').forEach(select => select.addEventListener('change', updateMasterSelectors))
})()
